import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import { baseUrl } from '../libs/constant';

var I18nLink = function I18nLink(_ref, _ref2) {
  var to = _ref.to,
      children = _ref.children,
      absolute = _ref.absolute,
      disableI18n = _ref.disableI18n,
      rest = _objectWithoutPropertiesLoose(_ref, ["to", "children", "absolute", "disableI18n"]);

  var language = _ref2.language;
  var locale = language.locale;
  var url = to;

  if (locale && to && to.indexOf('/') === 0) {
    url = to.indexOf("/" + locale) === -1 ? "/" + locale + to : to;
  }

  if (['true', true].includes(disableI18n)) {
    url = url.replace("/" + locale, '');
  }

  var appDomain = process.env.GATSBY_APP_DOMAIN || '';

  if (process.env.NODE_ENV === 'production' && [true, 'true'].includes(absolute) && url.indexOf('/') === 0 && appDomain !== 'www.arcblock.io') {
    url = "" + baseUrl + url;
  }

  if (/^\/(?!\/)/.test(url)) {
    return /*#__PURE__*/React.createElement(Link, Object.assign({
      to: url
    }, rest), children);
  }

  return /*#__PURE__*/React.createElement("a", Object.assign({
    href: url,
    target: "_blank"
  }, rest), children);
};

I18nLink.defaultProps = {
  absolute: false,
  disableI18n: false
};
I18nLink.contextTypes = {
  language: PropTypes.object
};
export default I18nLink;